import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import CampaignIndex from 'pages/builder/campaigns/campaign_index';
import BackEndExplainer from 'pages/creator/back_end_explainer';
import { AppUI } from '@seedlang/state';
import PageTitle from 'components/common/page_title';
const Wrapper = styled.div`

`;

@observer
class SendEmail extends React.Component {

  render() {
    return (
      <Wrapper>
        <PageTitle>Send Email</PageTitle>
        <BackEndExplainer>You can set up and send one-time emails to users here.</BackEndExplainer>
        <div className='breadcrumbs-wrapper'>
          <div className='breadcrumbs'>
            <div className='current'>
              Send Email
            </div>
          </div>
        </div>
        <fieldset>
          <legend>Emails</legend>
          <CampaignIndex
            oneTimeSending={true}
            groupId={AppUI.groupId}
            whiteLabeled={true}
            campaignTypeId='one-time'
            mobileNotification={false}
          />
        </fieldset>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(SendEmail);
